import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `movimientoVerraco/addMovimientoVerraco`, method: 'POST', body: values, token: token})
}
